/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import { DataContainer, DataItem } from "~/components";
import { useCurrency } from "~/hooks";
import { formatMoney, isNotNil } from "~/tools";
import { EstateGroupBy } from "./types";

type Props = {
  chartType: EstateGroupBy;
  totalTop: string;
  totalOther: string;
  count?: number | null;
  isLoading?: boolean;
};

export function Top10CostData({
  chartType,
  count,
  isLoading = false,
  totalTop,
  totalOther,
}: Props) {
  const { currency } = useCurrency();

  const label = mapLabel(chartType);
  const totalCost = Number(totalTop) + Number(totalOther);

  return (
    <DataContainer width="100%">
      <DataItem
        label="Total Cost"
        value={formatMoney(totalCost, currency)}
        grow={false}
        loading={isLoading}
        valueFontWeight={theme.fontWeights.medium}
        itemWidth="20%"
      />
      <DataItem
        label={`Top 10 Spending ${label}`}
        value={isNotNil(totalTop) ? formatMoney(totalTop, currency) : "-"}
        grow={false}
        loading={isLoading}
        valueFontWeight={theme.fontWeights.medium}
        itemWidth="20%"
      />
      <DataItem
        label={`All other ${label}`}
        grow={false}
        valueFontWeight={theme.fontWeights.medium}
        loading={isLoading}
        itemWidth="20%"
        value={isNotNil(totalOther) ? formatMoney(totalOther, currency) : "-"}
      />
      <DataItem
        label={`Total ${label}`}
        grow={false}
        valueFontWeight={theme.fontWeights.medium}
        loading={isLoading}
        itemWidth="20%"
        value={isNotNil(count) ? count?.toString() : "-"}
      />
    </DataContainer>
  );
}

// Map other Top10 options here when implemented
function mapLabel(chartType: EstateGroupBy) {
  if (chartType === EstateGroupBy.APP) {
    return "Applications";
  }
  return "";
}
